<div class="mb-3 row">
    <label [attr.for]="inputId" class="form-label">
        {{ label }}
        <sup *ngIf="required" class="text-danger">*</sup>
        <button
            *ngIf="tooltip"
            type="button"
            class="btn btn-outline-success rounded-circle p-0 tooltip-icon-btn ms-1"
            [attr.aria-label]="tooltip"
            (click)="mostrarTooltip()">
            <i class="fas fa-question"></i>
        </button>
    </label>
    <div>
        <div class="input-group">
            <input
                class="form-control"
                [id]="inputId"
                [placeholder]="placeholder"
                [disabled]="disabled"
                [matDatepicker]="picker"
                [min]="minDate"
                [max]="maxDate"
                [value]="value"
                [class.is-invalid]="showError"
                (dateChange)="onDateChange($event.value)"
                (dateInput)="onDateChange($event.value)"
                (blur)="onBlur()" />
            <button
                class="btn btn-outline-secondary"
                type="button"
                [disabled]="disabled"
                (click)="picker.open()">
                <i class="fas fa-calendar-alt"></i>
            </button>
        </div>
        <mat-datepicker
            #picker
            panelClass="app-input-date-overlay"></mat-datepicker>
    </div>
    <div *ngIf="showError" class="invalid-feedback d-block">
        {{ requiredError }}
    </div>
    
</div>
